import { Tag } from 'primereact/tag'

import {
  DeliveryForecastItemSplit,
  DespatchAdvice,
  DespatchAdviceItem,
  Invoice,
  InvoiceItem,
  OrderResponse,
  OrderResponseItem,
} from '../../data/models'
import i18n from '../../utils/i18n'

export type StatusTagProps = {
  id?: string
  status:
    | OrderResponse['ConfirmationCode']
    | OrderResponseItem['ConfirmationCode']
    | DespatchAdvice['ConfirmationCode']
    | DespatchAdviceItem['ConfirmationCode']
    | Invoice['ConfirmationCode']
    | InvoiceItem['ConfirmationCode']
    | DeliveryForecastItemSplit['Status']
  className?: string
}

export const StatusTag: React.FC<StatusTagProps> = ({
  id,
  status,
  className,
}) => {
  if (!status) return null

  return (
    <Tag
      id={id}
      className={`text-xs font-bold px-2 ${getClassName(status)} ${
        className ? className : ''
      }`}
      icon={getStatusIcon(status)}
    >
      {i18n.t(`common.codes.status.${status!.toLowerCase()}`)}
    </Tag>
  )
}

const getClassName = (code: StatusTagProps['status']) => {
  switch (code) {
    case 'NOT_SET':
      return 'surface-200 text-gray-900'

    case 'MODIFIED':
      return 'bg-orange-200	text-orange-900'

    case 'ACCEPTED':
    case 'ADDED':
      return 'bg-green-200 text-green-900'

    case 'REJECTED':
      return 'bg-red-200 text-red-900'

    default:
      return 'bg-purple-200 text-purple-900'
  }

  // ready
  // error
  // none
  // undefined

  // .p-taginactive. {
  //   background: var(--orange-200);
  //   color: var(--orange-900);
  // }
  // .p-tag.active {
  //   background: var(--green-200);
  //   color: var(--green-900);
  // }
  // .p-tag.ready {
  //   background: var(--green-200);
  //   color: var(--green-900);
  // }
  // .p-tag.error {
  //   background: var(--red-200);
  //   color: var(--red-900);
  // }
  // .p-tag.none {
  //   background: var(--yellow-200);
  //   color: var(--yellow-900);
  // }
  // .p-tag.undefined {
  //   background: var(--purple-200);
  //   color: var(--purple-900);
  // }
}

const getStatusIcon = (code: StatusTagProps['status']) => {
  switch (code) {
    case 'NOT_SET':
      return 'pi pi-circle'

    case 'MODIFIED':
      return 'pi pi-pencil'

    case 'ACCEPTED':
      return 'pi pi-check'

    case 'REJECTED':
      return 'pi pi-times'

    case 'ADDED':
      return 'pi pi-plus'

    default:
      return 'pi pi-question'
  }
}
